<div class="confirm-modal ig-modal">
    <div class="close-button">
        <mat-icon (click)="close()">clear</mat-icon>
    </div>
    <div class="title">ADD CITY</div>

    <div *ngIf="data.isNoFeeds">
        <div class="empty-list">No location feeds, please go to "Content Management" and add some grofences...</div>
    </div>

    <div *ngIf="!allCities.length&&!data.isNoFeeds">
        <div class="empty-list">All cities have been added to this region.</div>
    </div>

    <ng-container *ngIf="!data.isNoFeeds">
        <div>
            <div #div class="full-width m-t-3" *ngIf="allCities.length">
                <form ngForm="searchFormGroup" class="search-city-form">
                    <ig-field #field label="filter city" style="padding: 0 8px"
                              [isInnerLabel]="true"
                              [formControl]="searchFormGroup.get('search')"
                              icon="search"
                              [(ngModel)]="searchText"
                              (keyup)="search()">
                    </ig-field>
                </form>

                <div style="padding: 0 8px;text-align: left; height:250px;overflow-y: auto;">
                    <div *ngFor="let feed of data.locationFeeds">
                        <mat-checkbox [(ngModel)]="feed.isInRegion"
                                      (ngModelChange)="toggle(feed)">{{feed.locationFeed.cityTitle || feed.locationFeed.title}}
                        </mat-checkbox>
                    </div>
                </div>

            </div>
        </div>
    </ng-container>

    <ig-row *ngIf="!data.isNoFeeds&&data.locationFeeds.length" [pinCenter]="true">
        <ig-col [xs]="6">
            <ig-button class="btn-primary" color="primary" size="md" [isAsync]="true"
                       (trigger)="confirm($event)">
                Save
            </ig-button>
        </ig-col>
    </ig-row>
    <div class="cancel-btn" (click)="close()">
        Cancel
    </div>
</div>


// WEBPACK FOOTER //
// D:/Work/Development/ImGoing/IMGoing/web/src/components/hub/add.city.modal/add.city.modal.component.html